<template>
    <div>
        <b-toast id="toast-check-modal-change-time-zone" variant="none" no-close-button toaster="b-toaster-top-center">
            <img src="@/assets/img/ico-check.png" style="margin-right: 10px; margin-top: -2px"/>
            {{ messageRegister }}
        </b-toast>
        <b-toast id="toast-equis-modal-change-time-zone" variant="none" no-close-button toaster="b-toaster-top-center">
            <img src="@/assets/img/ico-equis.png" style="margin-right: 10px; margin-top: -2px"/>
            {{ messageRegister }}
        </b-toast>
        <b-modal id="modal-change-time-zone" :hide-header="true" :centered="true" @hide="listTimeZones">
                <img class="close" src="@/assets/img/close_red.png" @click="close">
                <h6 class="sub-title mb-4">
                    <span>{{$t('settings.timezone.subtitle')}}</span>
                </h6>
                <template v-if="optionsTimeZone.length > 0">
                <CustomSelect  value="valor"  @input="idSelected"  :options="optionsTimeZone"  label="descripcion" :default="dataField" />
                </template>
            <template #modal-footer>
                <b-button @click="updateTimeZone"  :class="{ loading: isLoading }" variant="primary">{{$t('reusables.save')}}</b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
import { baseInstanceAxios } from '@/assets/js/axiosBase.js'; 
import imgMjeExito from '@/assets/img/ico-check.png'
import imgMjeError from '@/assets/img/ico-equis.png'
import CustomSelect from "@/components/form/select";
import { getHoursByTimeZoneName } from '@/assets/js/util.js';

export default {
	name:"modalChangeTimeZone",
    components:{
        CustomSelect
    },
	data() {
		return {
            selected: this.$store.state.user.timeZoneName,
            optionsTimeZone: [],
            isLoading: false,
            messageRegister: "",
            imgMjeRegistro: imgMjeExito,
            dataField: '',
            message: ''
        };
	},
	mounted() {
        this.listTimeZones();
    },
	methods: {
    idSelected(event){
        this.selected = event
    },
    close(){
        this.$bvModal.hide('modal-change-time-zone')
    },
    listTimeZones() {
        baseInstanceAxios
        .get(this.apiURL + `/Administration/TimeZone/List`)
        .then(response => {
            if (response.data != null && response.data.list ) {
                this.optionsTimeZone = response.data.list;
                this.dataField = this.optionsTimeZone.filter(o => o.valor == this.selected)[0].descripcion;
            }
        });
    },
    updateTimeZone(){
        if(this.selected == null){
            this.$bvModal.hide("modal-change-time-zone");
            return;
        }

        let data = {
            id: this.$store.state.user.id,
            timeZoneName: this.selected
        };
        this.isLoading = true;

        baseInstanceAxios
            .post(this.apiURL + `/resources/Persons/UpdateTimeZone`, data)
            .then(response => {
                if (response.data != null && response.data.return) {

                    this.$store.state.user.timeZoneName = data.timeZoneName;
                    this.$store.commit("mutateUser", this.$store.state.user);		

                    this.messageRegister = 'Your timezone was updated.';
                    this.imgMjeRegistro = imgMjeExito;
                    this.$bvToast.show("toast-register");

                    let GMT = getHoursByTimeZoneName(this.$moment, data.timeZoneName);
                    document.querySelector('.fc-timegrid-axis-frame').innerHTML = GMT;
                    this.$emit('updateCalendar');
                }else{
                    this.messageRegister = this.$t('mjesRegistro.mjeActualizacionError');
                    this.imgMjeRegistro = imgMjeError;
                    this.$bvToast.show("toast-register");
                }
                this.isLoading = false;
                this.$bvModal.hide("modal-change-time-zone");
            })
            .catch(error =>{
                console.log(error);
                this.messageRegister = this.$t('mjesRegistro.mjeActualizacionError');
                this.imgMjeRegistro = imgMjeError;
                this.$bvToast.show("toast-register");
                this.isLoading = false;
            });
    }
  }
}
</script>